import React from "react";

export default function Credit() {
  return (
    <div class="credit">
    <p>
      Coded by
      <a href="https://www.shecodes.io/graduates/73033-chaimae-lamirine"
        > Chaimae Lamirine</a
      >, <a href="https://github.com/shemmee/React-Weather-App">Open sourced on Github.</a> Hosted on Netlify
    </p>
  </div>
  );
}